import {useEffect} from "react"
import {logout, useSelectedToken, useSelectedExpiresAt} from "./authSlice"
import {useDispatch} from "react-redux"
import {resetSessionData} from "../session/resetSessionData"

const AuthProvider = () => {
    const token = useSelectedToken()
    const expiresAt = useSelectedExpiresAt()
    const dispatch = useDispatch()

    useEffect(() => {
        if(expiresAt && token) {
            if(expiresAt && Date.now() > Number(expiresAt)) {
                dispatch(logout())
                resetSessionData()
            }
        }
    }, [expiresAt, token, dispatch])

    return null
}

export default AuthProvider
